


















































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import {namespace} from "vuex-class";
import i18n from "@/plugins/translations/t";

const Auth = namespace("Auth");

const API_URL = process.env.VUE_APP_API_PATH + '/';


@Component
export default class App extends Vue {
    @Auth.State("user")
    private currentUser!: any;

    @Auth.Action
    private signOut!: () => void;

    @Auth.Action
    private loginSuccess!: (user: any) => void;

    private currentView: string = this.$route.name ?? "hildegard";

    flagClasses = {
        "uk": ["fi", "fi-ua"],
        "en": ["fi", "fi-gb"],
        "et": ["fi", "fi-ee"],
        "la": ["fi", "fi-kids"]
    }

    get currentLang() {
        return i18n.locale;
    }


    set currentLang(val: string) {
        i18n.locale = val
        this.$router.push({name: this.$route.name ?? "", params: {...this.$route.params, lang: val}})
    }

    private languages = [
        {
            text: "Eesti",
            value: "et"
        },
        {
            text: "English",
            value: "en"
        },
        {
            text: "Український",
            value: "uk"
        },
        {
            text: "Lastele",
            value: "la"
        }
    ]

    get showLogin() {
        return !this.currentUser;
    }

    get isMobile() {
        return this.$vuetify.breakpoint.name === "xs";
    }

    drawer = false;

    get isDrawer() {
        return !this.isMobile || this.drawer;
    }

    set isDrawer(val: boolean) {
        this.drawer = !this.isMobile || val;
    }

    get showAdminBoard(): boolean {
        if (this.currentUser && this.currentUser.roles) {
            return this.currentUser.roles.includes("ROLE_ADMIN");
        }

        return false;
    }

    get showModeratorBoard(): boolean {
        if (this.currentUser && this.currentUser.roles) {
            return this.currentUser.roles.includes("ROLE_MODERATOR");
        }

        return false;
    }

    @Watch("$route")
    routeChanged() {
        this.currentView = this.$route.name ?? "home"
    }

    logOut() {
        this.signOut();
        this.$router.push({name: "hildegard", params: {lang: this.$route.params.lang}});
    }

    @Watch("currentView")
    currentViewChanged(curr: string, prev: string) {
        this.isDrawer = false;

        if (curr !== prev && this.$route.name !== curr) {
            this.$router.push({name: curr, params: {lang: this.$route.params.lang}})
        }
    }

    created() {
        this.$router.onReady(() => {
            i18n.locale = this.$route.params.lang ?? "et";
        });
    }

    @Auth.Action
    private loadUser!: () => void;

    mounted() {
        if (!this.currentUser) {
            this.loadUser();
        }
    }

    downloadLog() {
        window.location.href = API_URL + "api/plantlog"
    }
}
